// extracted by mini-css-extract-plugin
export default {"dropdown":"TasksDropdown-styles-module--dropdown--tU8pM"};